// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as Category$Showside from "../types/Category.bs.js";
import * as Accordion$Showside from "./Accordion.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as ProductCard$Showside from "./ProductCard.bs.js";
import * as ListPageGrid$Showside from "./ListPageGrid.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as SectionContent$Showside from "./SectionContent.bs.js";
import * as PlaceholderCard$Showside from "./PlaceholderCard.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as PDPStickyDetails$Showside from "./PDPStickyDetails.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as RelatedMediaContent$Showside from "./RelatedMediaContent.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ProductDetailsConfig$Showside from "../types/ProductDetailsConfig.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PDPContentDetailsCard$Showside from "./PDPContentDetailsCard.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ProductDetailsConfigId.bs.js";
import * as RelatedProductsContent$Showside from "./RelatedProductsContent.bs.js";
function useMoreSections(separatorOpt, productCategory, showEnhanceContentOpt, showRelatedProductsOpt, showRelatedMediaOpt, isInsideQuickViewOpt, showMoreProductsOpt, descriptionLayout, shouldForceMobileOpt, relatedProductsLayout, scrollableContainerRef, hideRelatedProductId, layoutOpt, product, selectedVariant, param) {
  var separator = separatorOpt !== undefined ? separatorOpt : true;
  var showEnhanceContent = showEnhanceContentOpt !== undefined ? showEnhanceContentOpt : true;
  var showRelatedProducts = showRelatedProductsOpt !== undefined ? showRelatedProductsOpt : true;
  var showRelatedMedia = showRelatedMediaOpt !== undefined ? showRelatedMediaOpt : true;
  var showMoreProducts = showMoreProductsOpt !== undefined ? showMoreProductsOpt : true;
  var shouldForceMobile = shouldForceMobileOpt !== undefined ? shouldForceMobileOpt : false;
  var entrypointContext = EntrypointContext$Showside.use(undefined);
  var pdpConfig = ProductDetailsContext$Showside.use(undefined);
  var isMiniPDPVisible = entrypointContext.isMiniPDPVisible;
  var onOpenLink = entrypointContext.onOpenLink;
  var onProductClick = entrypointContext.onProductClick;
  var onAddToCart = entrypointContext.onAddToCart;
  var trackEvent = entrypointContext.trackEvent;
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match = ConfigurationProvider$Showside.use(undefined);
  var config = match.config;
  var settings = config.settings;
  var match$1 = RouterProvider$Showside.useRouter(undefined);
  var relatedProductId = match$1.relatedProductId;
  var anyProductId = match$1.anyProductId;
  var listPageType = match$1.listPageType;
  var route = match$1.route;
  var match$2 = ViewportContext$Showside.use(undefined);
  var relatedMediaSlider = RelatedMediaContent$Showside.useSlider(undefined, /* PDP */0, scrollableContainerRef, {
    TAG: /* ByProductIds */0,
    _0: [product.id]
  }, undefined, undefined, undefined, undefined);
  var isMobile = match$2.isMobile || shouldForceMobile;
  var isQuickView;
  isQuickView = typeof route === "number" || route.TAG !== /* QuickView */3 ? false : true;
  var cardShape = settings.productCardShape;
  var shouldShowProductsFromCollection = !Category$Showside.ExternalConnection.isConnectedToProductSource(productCategory) && Category$Showside.getProductIds(productCategory).length === 0 || isQuickView;
  var onRelatedProductClick = React.useCallback(function (relatedProduct) {
    return function (variant) {
      var tmp;
      tmp = typeof route === "number" || route.TAG !== /* QuickView */3 ? undefined : route._0.mediaId;
      Curry.app(trackEvent, ["product details:other products", undefined, undefined, product, selectedVariant, relatedProduct, undefined, undefined, tmp, undefined, undefined, undefined, undefined, undefined, undefined, undefined]);
      return Curry._2(onProductClick, relatedProduct, variant);
    };
  }, [trackEvent, product.id, onProductClick]);
  var contextValue = React.useMemo(function () {
    var newrecord = Caml_obj.obj_dup(entrypointContext);
    newrecord.onProductClick = onRelatedProductClick;
    return newrecord;
  }, [entrypointContext, onRelatedProductClick]);
  var columns = isMobile ? /* TwoColumnGrid */1 : /* FourColumnGrid */3;
  var renderRelatedProductsPlaceholder = function (param) {
    return React.createElement(ListPageGrid$Showside.make, {
      columns: columns,
      children: [React.createElement(PlaceholderCard$Showside.make, {
        shape: cardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: "infinite-0"
      }), React.createElement(PlaceholderCard$Showside.make, {
        shape: cardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: "infinite-1"
      }), React.createElement(PlaceholderCard$Showside.make, {
        shape: cardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: "infinite-2"
      }), React.createElement(PlaceholderCard$Showside.make, {
        shape: cardShape,
        kind: /* Product */0,
        contentBoxStylableClassName: "product-card__content-box",
        titleStylableClassName: "category-card__title",
        key: "infinite-3"
      })],
      paddingOverride: 0
    });
  };
  var renderRelatedProducts = function (param) {
    if (shouldShowProductsFromCollection) {
      return Caml_option.some(React.createElement(RelatedProductsContent$Showside.make, {
        productId: relatedProductId !== undefined ? relatedProductId : anyProductId !== undefined ? anyProductId : "",
        categoryId: Belt_Option.getWithDefault(Belt_Option.flatMap(listPageType, function (id) {
          if (typeof id === "number" || id.TAG !== /* Category */0) {
            return;
          } else {
            return id._0;
          }
        }), ""),
        hideOutOfStock: settings.hideOutOfStock,
        viewport: scrollableContainerRef,
        render: function (products) {
          var cards = Belt_Array.mapWithIndex(products, function (dataCount, product) {
            var tmp = {
              shape: cardShape,
              productCategory: productCategory,
              product: product,
              onClick: onProductClick,
              onAddToCart: onAddToCart,
              onOpenLink: onOpenLink,
              dataCount: dataCount,
              key: product.id
            };
            if (isMiniPDPVisible !== undefined) {
              tmp.isMiniPDPVisible = Caml_option.valFromOption(isMiniPDPVisible);
            }
            return React.createElement(ProductCard$Showside.make, tmp);
          });
          return React.createElement(ListPageGrid$Showside.make, {
            columns: columns,
            children: cards,
            paddingOverride: 0
          });
        },
        displayVariantBySelector: displayVariantBy
      }));
    }
  };
  var productDetails = Accordion$Showside.makeSection(undefined, "description", Caml_option.some(React.createElement(PDPContentDetailsCard$Showside.DetailedAccordions.make, {
    variant: selectedVariant,
    product: product
  })), undefined, undefined, separator, undefined, undefined);
  var productsContentLayout = React.useMemo(function () {
    return {
      TAG: /* GridLayout */1,
      _0: {
        columns: /* TwoColumnGrid */1,
        gap: /* Half */1,
        maxRows: undefined,
        maxWidth: undefined,
        padding: undefined,
        pattern: undefined
      }
    };
  }, []);
  var productsContentLayout$1 = Belt_Option.getWithDefault(relatedProductsLayout, productsContentLayout);
  var forcedSize = relatedProductsLayout !== undefined ? undefined : /* Lg */5;
  var tmp;
  if (showMoreProducts && !shouldShowProductsFromCollection) {
    if (showRelatedProducts) {
      var match$3 = Category$Showside.ExternalConnection.getConnection(productCategory);
      var tmp$1;
      if (match$3 !== undefined) {
        if (typeof match$3 === "number") {
          switch (match$3) {
            case /* History */0:
              tmp$1 = /* History */3;
              break;
            case /* Favorites */1:
              tmp$1 = /* Favorites */2;
              break;
            case /* StoreCart */2:
              tmp$1 = /* StoreCart */4;
              break;
          }
        } else {
          tmp$1 = match$3.TAG === /* StoreCategory */0 ? /* Products */0 : /* Category */1;
        }
      } else {
        tmp$1 = /* Products */0;
      }
      var tmp$2 = {
        index: 3,
        preferredContentType: tmp$1,
        shouldShowHeader: false,
        isZoomEnabled: false,
        category: productCategory,
        refreshUserSavedProducts: false,
        layout: productsContentLayout$1,
        scrollableContainerRef: scrollableContainerRef,
        isPaddingEnabled: false,
        isThemeEnabled: false
      };
      if (forcedSize !== undefined) {
        tmp$2.forcedSize = Caml_option.valFromOption(forcedSize);
      }
      var content = React.createElement(SectionContent$Showside.make, tmp$2);
      tmp = Caml_option.some(React.createElement(EntrypointContext$Showside.Provider.make, {
        value: contextValue,
        children: React.createElement(ConditionalRender$Showside.When.make, {
          condition: isMobile,
          children: React.createElement(ConditionalRender$Showside.RenderAfterLCP.make, {
            children: content,
            fallbackElement: React.createElement("div", undefined, "Loading...")
          }),
          fallback: content
        })
      }));
    } else {
      tmp = Caml_option.some(renderRelatedProductsPlaceholder(undefined));
    }
  } else {
    tmp = undefined;
  }
  var moreSections = [Accordion$Showside.makeSection({
    TAG: /* Element */1,
    _0: null
  }, "enhance section", showEnhanceContent && pdpConfig.enhanceSections.length !== 0 ? Caml_option.some(React.createElement("div", {
    className: CSS$Showside.prefix("flex flex-col space-y-4")
  }, Belt_Array.keepMap(Belt_Array.map(pdpConfig.enhanceSections, function (section) {
    var content = ProductDetailsConfig$Showside.EnhanceSection.renderContent(undefined, undefined, isMobile || settings.desktopPDPLayout === /* Old */0, product, selectedVariant, config, section);
    var heading = Belt_Option.mapWithDefault(Belt_Option.keep(section.showTitle, function (a) {
      return a;
    }), null, function (param) {
      return React.createElement("div", {
        className: CSS$Showside.prefix("text-xl font-semibold text-primary uppercase")
      }, section.title);
    });
    return Belt_Option.map(content, function (content) {
      return React.createElement(React.Fragment, {
        children: null,
        key: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.toString, section.id)
      }, heading, content);
    });
  }), function (a) {
    return a;
  }))) : undefined, undefined, undefined, undefined, undefined, undefined), Accordion$Showside.makeSection({
    TAG: /* Text */0,
    _0: "Related Media"
  }, "related media", showRelatedMedia ? relatedMediaSlider : undefined, undefined, undefined, undefined, undefined, undefined), Accordion$Showside.makeSection({
    TAG: /* Text */0,
    _0: "Products from this category"
  }, "products from this category", tmp, undefined, undefined, undefined, undefined, undefined), Accordion$Showside.makeSection({
    TAG: /* Text */0,
    _0: "Related products"
  }, "related products", showMoreProducts ? showRelatedProducts ? renderRelatedProducts(undefined) : Caml_option.some(renderRelatedProductsPlaceholder(undefined)) : undefined, undefined, undefined, separator, undefined, undefined)];
  if (descriptionLayout) {
    return Belt_Array.concat([productDetails], moreSections);
  } else {
    return moreSections;
  }
}
function PDPContentDetails(Props) {
  var product = Props.product;
  var variant = Props.variant;
  var productCategory = Props.productCategory;
  var shouldForceMobile = Props.shouldForceMobile;
  var isInsideQuickView = Props.isInsideQuickView;
  var scrollableContainerRef = Props.scrollableContainerRef;
  var scrollToDetailsRef = Props.scrollToDetailsRef;
  var stickyDetailsRef = Props.stickyDetailsRef;
  var showHeaderOpt = Props.showHeader;
  var titleStyleOpt = Props.titleStyle;
  var largeTitleStyleOpt = Props.largeTitleStyle;
  var optionSizeOpt = Props.optionSize;
  var optionStyleOpt = Props.optionStyle;
  var colorOptionSizeOpt = Props.colorOptionSize;
  var hideRelatedProductId = Props.hideRelatedProductId;
  var showEnhanceContentOpt = Props.showEnhanceContent;
  var showRelatedProductsOpt = Props.showRelatedProducts;
  var showRelatedMediaOpt = Props.showRelatedMedia;
  var showMoreProductsOpt = Props.showMoreProducts;
  var descriptionLayout = Props.descriptionLayout;
  var onCTAButtonVisibilityChange = Props.onCTAButtonVisibilityChange;
  var stickyCTA = Props.stickyCTA;
  var relatedProductsLayout = Props.relatedProductsLayout;
  var layoutOpt = Props.layout;
  var separatorOpt = Props.separator;
  var headerSize = Props.headerSize;
  var sections = Props.sections;
  var singleColumnHorizontalPadding = Props.singleColumnHorizontalPadding;
  var showHeader = showHeaderOpt !== undefined ? showHeaderOpt : true;
  var titleStyle = titleStyleOpt !== undefined ? titleStyleOpt : "semibold";
  var largeTitleStyle = largeTitleStyleOpt !== undefined ? largeTitleStyleOpt : "medium";
  var optionSize = optionSizeOpt !== undefined ? optionSizeOpt : /* Lg */3;
  var optionStyle = optionStyleOpt !== undefined ? optionStyleOpt : /* Border */0;
  var colorOptionSize = colorOptionSizeOpt !== undefined ? colorOptionSizeOpt : /* Lg */3;
  var showEnhanceContent = showEnhanceContentOpt !== undefined ? showEnhanceContentOpt : true;
  var showRelatedProducts = showRelatedProductsOpt !== undefined ? showRelatedProductsOpt : true;
  var showRelatedMedia = showRelatedMediaOpt !== undefined ? showRelatedMediaOpt : true;
  var showMoreProducts = showMoreProductsOpt !== undefined ? showMoreProductsOpt : true;
  var layout = layoutOpt !== undefined ? layoutOpt : /* SingleColumn */0;
  var separator = separatorOpt !== undefined ? separatorOpt : true;
  var store = StoreProvider$Showside.use(undefined);
  var match = ViewportContext$Showside.use(undefined);
  var match$1 = Favorites$Showside.useFavorites(undefined);
  var showRelatedMedia$1 = !isInsideQuickView && showRelatedMedia;
  var isMobile = match.isMobile || shouldForceMobile;
  var tmp = {
    productTitle: Product$Showside.getDisplayName(store, variant, product),
    product: product,
    variant: variant,
    onClick: function (e) {
      Curry._1(scrollToDetailsRef.current, undefined);
    },
    scrollToDetailsRef: scrollToDetailsRef
  };
  if (stickyDetailsRef !== undefined) {
    tmp.fwdRef = Caml_option.valFromOption(stickyDetailsRef);
  }
  var stickyDetailsContent = React.createElement(ConditionalRender$Showside.When.make, {
    condition: isMobile,
    children: React.createElement(PDPStickyDetails$Showside.make, tmp)
  });
  var moreSections = useMoreSections(separator, productCategory, showEnhanceContent, showRelatedProducts, showRelatedMedia$1, isInsideQuickView, showMoreProducts, descriptionLayout, shouldForceMobile, relatedProductsLayout, scrollableContainerRef, hideRelatedProductId, layout, product, variant, undefined);
  var tmp$1 = {
    product: product,
    variant: variant,
    productCategory: productCategory,
    shouldForceMobile: shouldForceMobile,
    scrollToDetailsRef: scrollToDetailsRef,
    showHeader: showHeader,
    titleStyle: titleStyle,
    largeTitleStyle: largeTitleStyle,
    optionSize: optionSize,
    optionStyle: optionStyle,
    colorOptionSize: colorOptionSize,
    moreSections: moreSections,
    layout: layout,
    showFavoriteButton: match$1.enabled
  };
  if (onCTAButtonVisibilityChange !== undefined) {
    tmp$1.onCTAButtonVisibilityChange = Caml_option.valFromOption(onCTAButtonVisibilityChange);
  }
  if (headerSize !== undefined) {
    tmp$1.headerSize = Caml_option.valFromOption(headerSize);
  }
  if (stickyCTA !== undefined) {
    tmp$1.stickyCTA = stickyCTA;
  }
  if (sections !== undefined) {
    tmp$1.sections = Caml_option.valFromOption(sections);
  }
  if (singleColumnHorizontalPadding !== undefined) {
    tmp$1.singleColumnHorizontalPadding = Caml_option.valFromOption(singleColumnHorizontalPadding);
  }
  return React.createElement(React.Fragment, undefined, React.createElement(PDPContentDetailsCard$Showside.make, tmp$1), stickyDetailsContent);
}
PDPContentDetails.displayName = "PDPContentDetails";
var make = PDPContentDetails;
export { useMoreSections, make };
/* react Not a pure module */